import { useState, useEffect } from 'react';
import { map } from 'lodash'

import rMateDB from '../../../documents/Primaria/regularizacionMate.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardAll from '../../../components/Cards/CardAll/CardAll';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './RegularizacionMate.scss';

export default function RegularizacionMate() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(rMateDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="regularizacion-mate">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="regularizacion-mate__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="regularizacion-mate__titulo">Regularización Matemáticas</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardAll
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}